import { render, staticRenderFns } from "./NewRefundWarning.vue?vue&type=template&id=1ecd31a3&scoped=true&"
import script from "./NewRefundWarning.vue?vue&type=script&lang=js&"
export * from "./NewRefundWarning.vue?vue&type=script&lang=js&"
import style0 from "./NewRefundWarning.vue?vue&type=style&index=0&id=1ecd31a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd31a3",
  null
  
)

export default component.exports